// Local translations
export const T = {
  en_GB: {
    noData: "No forecast data available.",
    lower: "Lower (5%)",
    expected: "Expected",
    upper: "Upper (95%)",
    expectedReturn: "Expected Return",
    volatility: "Volatility",
    snapshotTaken: (time: string) => `Snapshot taken ${time}`,
  },
  nb_NO: {
    noData: "Ingen prognosedata tilgjengelig.",
    lower: "Nedre (5%)",
    expected: "Forventet",
    upper: "Øvre (95%)",
    expectedReturn: "Forventet avkastning",
    volatility: "Volatilitet",
    snapshotTaken: (time: string) => `Øyeblikksbilde tatt ${time}`,
  },
} as const;
